import { gql } from '@apollo/client';

const GREASE_TRAP_FIELDS = gql`
  fragment GreaseTrapFields on VendorGreaseTrap {
    id
    vendor_id
    driver_id
    truck_id
    location_id
    date_service
    gross_pounds
    container_volume
    vehicle_decal_number
    gallons_grease_received
    traceability
    manifest_number
    price_per_gallon
    total_amount
    transaction_id
    status
    createdAt
    vendor {
      id
      name
    }
    driver {
      id
      name
    }
    truck {
      id
      license_plate
      tk
      capacity
    }
    location {
      id
      name
    }
    registered_by {
      id
      name
    }
    payments {
      id
      grease_trap_id
      transaction_id
      amount
      payment_type
      check_number
      transaction_number
      paid_at
      createdAt
    }
    documents {
      id
      name
      type
      date
      url
    }
  }
`;

export const GET_GREASE_TRAPS = gql`
  query GetGreaseTraps(
    $vendorId: ID
    $statusFilter: String
    $startDate: String
    $endDate: String
    $limit: Int
    $offset: Int
  ) {
    getGreaseTraps(
      vendorId: $vendorId
      statusFilter: $statusFilter
      startDate: $startDate
      endDate: $endDate
      limit: $limit
      offset: $offset
    ) {
      ...GreaseTrapFields
    }
  }
  ${GREASE_TRAP_FIELDS}
`;

export const GET_VENDOR_GREASE_TRAPS = gql`
  query GetVendorGreaseTraps(
    $vendorId: ID!
    $statusFilter: String
    $limit: Int
    $offset: Int
  ) {
    getVendorGreaseTraps(
      vendorId: $vendorId
      statusFilter: $statusFilter
      limit: $limit
      offset: $offset
    ) {
      ...GreaseTrapFields
    }
  }
  ${GREASE_TRAP_FIELDS}
`;

export const GET_SINGLE_GREASE_TRAP = gql`
  query GetSingleGreaseTrap($id: ID!) {
    getSingleGreaseTrap(id: $id) {
      ...GreaseTrapFields
    }
  }
  ${GREASE_TRAP_FIELDS}
`;

export const GET_GREASE_TRAP_OPTIONS = gql`
  query GetGreaseTrapOptions($vendorId: ID) {
    getGreaseTrapOptions(vendorId: $vendorId) {
      userOptions {
        label
        value
      }
      driverOptions {
        label
        value
        vendor_id
      }
      truckOptions {
        label
        value
        license_plate
        tk
        capacity
        vendor_id
      }
      locationOptions {
        label
        value
        measuring_method
      }
      vendorOptions {
        label
        value
      }
    }
  }
`;

export const GET_GREASE_TRAP_STATS = gql`
  query GetGreaseTrapStats($vendorId: ID!) {
    getGreaseTrapStats(vendorId: $vendorId) {
      totals {
        gallons_grease_received
        total_amount
      }
      last10 {
        id
        gallons_grease_received
        total_amount
        date_service
        status
      }
      lastPayments {
        amount
        type
      }
      totalPayments
    }
  }
`;

export const GET_GREASE_TRAP_GLOBAL_STATS = gql`
  query GetGreaseTrapGlobalStats(
    $vendorId: ID
    $statusFilter: String
    $startDate: String
    $endDate: String
  ) {
    getGreaseTrapGlobalStats(
      vendorId: $vendorId
      statusFilter: $statusFilter
      startDate: $startDate
      endDate: $endDate
    ) {
      total_pounds
      total_amount
      pending_balance
    }
  }
`;

export const GET_GREASE_TRAP_PDF = gql`
  query GetGreaseTrapPdf($id: ID!) {
    getGreaseTrapPdf(id: $id)
  }
`;
